<template>
  <section
    id="get-in-touch"
    class="hide-overflow"
  >
    <v-layout
      info
      white--text
    >
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/possiblepics/work_typing_computer_notebook_programming_business_technology_internet-883504.jpg')"
          height="100%"
        />
      </v-flex>
      <v-flex
        xs12
        md6
        pa-5
      >
        <base-bubble-1 />
        <base-heading class="mb-5">
          Get In Touch
        </base-heading>

        <form @submit="formSubmit">
          <v-sheet
            max-width="600"
            color="transparent"
          >
            <v-text-field
              v-model="name"
              color="info"
              label="Name"
              solo
              flat
            />
            <v-text-field
              v-model="email"
              color="info"
              label="Email"
              solo
              flat
            />
            <v-text-field
              v-model="subject"
              color="info"
              label="Subject"
              solo
              flat
            />
            <v-textarea
              v-model="message"
              color="info"
              label="Message"
              solo
              flat
            />
            <v-btn type="submit" color="info">
             Send
            </v-btn>
          </v-sheet>
        </form>
      </v-flex>
    </v-layout>
  </section>
</template>
<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      subject: '',
      message: ''
    }
  },
  mounted () {
    console.log('Component mounted.')
  },
  methods: {
    async formSubmit (e) {
      e.preventDefault()
      if (this.name !== null && this.name.length > 0 &&
          this.email !== null && this.email.length > 0 &&
          this.subject !== null && this.subject.length > 0 &&
          this.message !== null && this.message.length > 0
      	){
	      let res = await this.axios.post('https://greenowl-it.com/api/api/mail/v1/send', {
	        name: this.name,
	        email: this.email,
	        subject: this.subject,
	        message: this.message
	      })
      }

      // phone: 01590-6346024 mail: info@greenowl-it.com adr: GreenOwl-IT An der Karrbrücke 14 18337 Marlow
    }
  }
}
</script>
